import React from 'react';

type WrapperProps = {
  condition: unknown;
  wrapper: Function;
  children: unknown;
};

const ConditionalWrapper: React.FunctionComponent<WrapperProps> = (props: WrapperProps) =>
  props.condition ? props.wrapper(props.children) : props.children;

export default ConditionalWrapper;
